import { ReactElement, ReactNode, SyntheticEvent } from 'react'

import { useTranslation } from 'react-i18next'

import { useAppConfig } from 'appConfig'
import { TextButton } from 'components/TextButton'
import { ToolTip } from 'components/ToolTip'
import { contactUsExternalUrl } from 'routing/urls'

interface Props {
    authenticated: boolean
    icon?: ReactElement
    link?: boolean
    className?: string
    children?: ReactNode
    contactUsPage?: string
}

const ContactUsLink = ({
    authenticated,
    children = 'Contact Us',
    ...rest
}: Props): ReactElement => {
    const { t } = useTranslation(['common'])
    const { isChinaBuild } = useAppConfig()

    const openServiceDesk = (e: SyntheticEvent): void => {
        e.preventDefault()

        window.open(contactUsExternalUrl(authenticated), '_blank')
    }

    if (!isChinaBuild) {
        return (
            <TextButton {...rest} inline onClick={openServiceDesk}>
                {children}
            </TextButton>
        )
    }
    return (
        <TextButton {...rest} inline>
            <ToolTip
                title={t('common:contactUsWeChat', 'Contact Us on WeChat')}
            >
                {children}
            </ToolTip>
        </TextButton>
    )
}

export default ContactUsLink
